import { create, el, awaitRedraw } from "@dhx/ts-common/dom";
import { View } from "@dhx/ts-common/view";
import { ISpacerHandlersMap, ItemEvent, ISpacerConfig, ISpacer, IBaseLayoutItem } from "../types";
import { IEventSystem, EventSystem } from "@dhx/ts-common/events";
import { isEmptyObj } from "@dhx/ts-common/core";
import { baseProps } from "../helper";

export class Spacer extends View implements ISpacer {
	public config: ISpacerConfig;
	public events: IEventSystem<ItemEvent, ISpacerHandlersMap>;
	constructor(container: HTMLElement | string, config) {
		super(container, {
			disabled: false,
			hidden: false,
			width: "content",
			height: "content",
			...config,
		});
		this.events = new EventSystem();

		if (this.config.hidden) {
			awaitRedraw().then(() => {
				this.hide(true);
			});
		}

		const render = () => this._draw();
		this.mount(container, create({ render }));
	}
	destructor() {
		this.events && this.events.clear();
		this.config = this.events = null;
		this.unmount();
	}
	setProperties(propertyConfig: IBaseLayoutItem): void {
		if (
			!propertyConfig ||
			isEmptyObj(propertyConfig) ||
			!this.events.fire(ItemEvent.beforeChangeProperties, [this.getProperties()])
		)
			return;

		for (const key in propertyConfig) {
			if (baseProps.includes(key)) {
				this.config[key] = propertyConfig[key];
			}
		}
		this.events.fire(ItemEvent.afterChangeProperties, [this.getProperties()]);
		this.paint();
	}
	getProperties(): IBaseLayoutItem {
		const obj: IBaseLayoutItem = {};
		for (const prop of baseProps) {
			obj[prop] = this.config[prop];
		}
		return obj;
	}
	show(): void {
		const { hidden } = this.config;
		if (!hidden || !this.events.fire(ItemEvent.beforeShow, [undefined])) {
			return;
		}
		this.config.hidden = false;
		this.events.fire(ItemEvent.afterShow, [undefined]);
	}
	hide(init?: boolean): void {
		const { hidden } = this.config;
		if ((hidden && !init) || !this.events.fire(ItemEvent.beforeHide, [undefined, init])) {
			return;
		}
		this.config.hidden = true;
		this.events.fire(ItemEvent.afterHide, [undefined, init]);
	}
	isVisible(): boolean {
		return !this.config.hidden;
	}
	protected _draw() {
		return el("div");
	}
}
